import React from "react";
import { Button } from "@agria/theme/src/components/button";

export const VetGuideDownload = () => {
    const playstoreLink =
      "https://play.google.com/store/apps/details?id=com.vethem&hl=en&gl=US";
    const appstoreLink =
      "https://apps.apple.com/gb/app/agria-vet-guide/id1410819467";
  
    // Work out if users current device is iOS or Android
  
    const isIOS = () => {
      if (typeof window !== "undefined") {
        const userAgent = navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod|macintosh/.test(userAgent);
      }
      return false;
    };
  
    return (
      <Button
        url={isIOS() ? appstoreLink : playstoreLink}
        label="Download Agria app"
        variant="primary"
        arrowRight
      />
    );
  };
  